import { NgModule, Component } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SummerInternshipsListComponent } from './summer-internships-list/summer-internships-list.component';
import { SummerInternshipsCreateComponent } from './summer-internships-create/summer-internships-create.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'list-page',
        component: SummerInternshipsListComponent,
        data: {
          title: "List Page",
          breadcrumb: "List Page"
        }
      },
      {
        path: 'create-page',
        component: SummerInternshipsCreateComponent,
        data: {
          title: "Create Page",
          breadcrumb: "Create Page"
        }
      },
      {
        path: 'summer-internships-create/:id',
        component: SummerInternshipsCreateComponent,
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SummerInternshipsRoutingModule { }
